import React, { Component, Fragment } from 'react';
import { BrowserRouter as Router, Route, Switch, withRouter } from "react-router-dom";


import { connect } from 'react-redux'
import { userLogin, userLogout } from '../../redux/auth/actions';

import {StripeProvider} from 'react-stripe-elements';

import Layout from '../../components/Layout/Layout';



import Dashboard from '../Dashboard/Dashboard';
import Marks from '../Marks/Marks';
import Jewels from '../Jewels/Jewels';
import Contact from '../Contact/Contact';
import Account from '../Account/Account';
import moment from 'moment';
import axios from "axios";

class PrivateApp  extends Component {

  componentDidMount(){
      axios.get("auth/infos").then(res =>{
          this.props.userLogin(res.data);
      });
      this.refresh = setInterval(()=>{
          axios.get("auth/infos").then(res =>{
            if(res.data.token_id && res.data.userinfos.lastlogin==this.props.userinfos.lastlogin){
              this.props.userLogin(res.data);
            }else{
              this.props.history.push('/login');
              this.props.userLogout();
            }
             
          });
      }, 3000);
  }
  componentWillUnmount(){
      clearInterval(this.refresh);
  }

  render(){

    return (
      <Fragment>
        <StripeProvider apiKey="pk_live_KOyXUMtsp7sktYTtD6ICB5MD00FJjrn7sX">
        <Layout>
          <Switch>
          <Route path="/marks" component={Marks} />
          <Route path="/jewels" component={Jewels} />
          <Route path="/contact" component={Contact} />
          <Route path="/account" component={Account} />
          <Route path="/" component={Dashboard} />
          </Switch>
        </Layout>
        </StripeProvider>
      </Fragment>
    );
  }
}

const mapStateToProps = (state)=>{
  return {
    token: state.auth.token,
    userinfos: state.auth.userinfos
  }
};


export default connect(mapStateToProps, {userLogin, userLogout})(PrivateApp);
